<app-sub-page class="width-100" navBackRoute="/standby">
  <div class="flex column width-100 flex-1 gap-05" style="max-width: 800px">
    <div class="flex column width-100 flex-1">
      <div class="flex column width-100 gap-05 scrollable" [style.height]="getContentHeight()">
        <div class="text-label">Defaults</div>
        <div
          class="flex column width-100 rounded-md gap-05"
          style="background-color: var(--surface-50); padding: 0.5rem"
        >
          <div class="flex width-100 flex-between align-center">
            <div class="label">VMAX</div>
            <input [value]="vmaxDefault" type="text" inputmode="numeric" (keydown)="onKeyDown($event, 'vmax')" />
          </div>
          <div class="flex width-100 flex-between align-center">
            <div class="label">PROJ</div>
            <input [value]="projDefault" type="text" inputmode="numeric" (keydown)="onKeyDown($event, 'proj')" />
          </div>
        </div>
        <div class="text-label">Plan Types</div>
        <div class="flex column width-100 rounded-md" style="background-color: var(--surface-50); padding: 0.5rem">
          @for (type of planTypes; track $index) {
          <div class="flex width-100 flex-between align-center">
            <div>{{ type.label }}</div>
            <app-button label="Preview" [outlined]="true" [text]="true" (click)="onPreviewClick(type)" />
          </div>
          }
        </div>
      </div>
    </div>
    <app-button
      label="Activate Standby Plan"
      severity="success"
      [outlined]="globalService.theme() === 'dark'"
      (click)="activatePlan()"
    />
  </div>
</app-sub-page>
@if (previewPlanVisible) {
<app-preview-plan
  [(visible)]="previewPlanVisible"
  [planType]="selectedPlanType"
  [defaults]="{vmaxDefault, projDefault}"
/>
}
